import { connect } from "react-redux";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export const mplConnector = connect(mapStateToProps, mapDispatchToProps);
